import { ToggleOptions } from 'rt-inputs';
import { UUID } from 'symbols';

export interface BasicMetaData {
  nextId: UUID;
  nextNumber: number;
}

export interface BasicModel {
  id: UUID;
  createdAt: string;
  version: number;
  isNew: boolean;
}

export interface AddressModel {
  street: string;
  city?: string;
  country?: string;
  location?: {
    lat?: number;
    lng?: number;
  };
}


export enum Sort {
  CREATED = 'createdAt',
  NUMBER = 'number',
  // спершу термінові (mobile: пріоритетні замовлення й стенди зверху списку)
  PRIORITY = 'isHighPriority',
}

export enum Order {
  DESC = 'DESC',
  ASC = 'ASC',
}


export interface SortOrder {
  sort: Sort;
  order: Order;
}


export enum TYPE_SEARCH {
  BY_NUMBER = 'BY_NUMBER',
  BY_METADATA = 'BY_METADATA',
}

export const TYPE_SEARCH_CHOICES: ToggleOptions[] = [
  {
    value: TYPE_SEARCH.BY_NUMBER,
    title: 'По номеру'
  },
  {
    value: TYPE_SEARCH.BY_METADATA,
    title: 'По метаданим'
  }
];

export interface TemplateGraphQLModel {
  html?: string;
  project?: Object;
  formatId?: UUID;
  name: string;
  css: string;
}

